import React, { useState, useEffect } from "react";
import ReactDOM from 'react-dom';
import { Platform } from 'react-native';
import Slider from "react-slick";
import { useBanners } from "../../../BannerManager"; // tu hook de banners
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BACKEND_URL } from "../../../../Config/Const";
import ArrowButton from '../../../Common/ArrowButton';

// Estilos adicionales para el carrusel (scoped) con breakpoints granulares
const carouselStyles = `
  .banner-bancario-web {
    width: 100%;
    padding: 10px 0;
    /* El padding lateral se hereda del contenedor padre */
  }
  .banner-bancario-web .bnw-inline-row {
    display: flex;
    align-items: center;
    gap: 16px;
    width: 100%;
  }
  .banner-bancario-web .bnw-inline-actions {
    flex: 0 0 auto;
  }
  .banner-bancario-web .bnw-slider-col {
    flex: 1 1 auto;
    min-width: 0;
    position: relative;
    width: 100%;
  }
  .banner-bancario-web .bnw-slider-col .slick-slider {
    width: 100%;
  }
  .banner-bancario-web .bnw-mobile-btn { display: none; }
  .banner-bancario-web .slick-list {
    overflow: hidden;
    height: 200px;
    margin: 0 -12px;
  }
  .banner-bancario-web .slick-track {
    display: flex !important;
    align-items: center;
    justify-content: center;
    height: 200px;
  }
  .banner-bancario-web .slick-slide {
    float: left;
    display: flex;
    justify-content: center;
    height: 200px;
    min-height: 1px;
    padding: 0 12px;
    box-sizing: border-box;
  }
  .banner-bancario-web .slick-slide > div {
    width: 100% !important;
    max-width: 100%;
    margin: 0;
    height: 200px;
    display: flex;
    align-items: center;
  }
  .banner-bancario-web img {
    display: block;
    width: 100%;
    height: 100%;
    max-height: 200px;
    object-fit: contain;
    border-radius: 8px;
  }
  /* Custom arrows */
  .banner-bancario-web .bnw-arrow {
    position: absolute;
    top: 58%;
    transform: translateY(-20px);
    width: 40px;
    height: 40px;
    border-radius: 25px;
    background: rgba(252, 1, 1, 0.6);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    cursor: pointer;
    z-index: 2;
    transition: background 0.2s ease;
  }
  .banner-bancario-web .bnw-arrow:hover {
    background: rgba(252, 1, 1, 0.8);
  }
  .banner-bancario-web .bnw-arrow.prev { left: 8px; }
  .banner-bancario-web .bnw-arrow.next { right: 8px; }
  .banner-bancario-web .bnw-arrow svg { width: 18px; height: 18px; }
  .banner-bancario-web .bnw-arrow:disabled { opacity: .5; cursor: default; }

  /* Extra pequeño - Móviles muy pequeños */
  @media (max-width: 400px) {
    .banner-bancario-web .slick-list { height: 150px; margin: 0; }
    .banner-bancario-web .slick-track { height: 120px; }
    .banner-bancario-web .slick-slide { height: 86px; padding: 0; width: 100% !important; }
    .banner-bancario-web .slick-slide > div { height: 120px; }
    .banner-bancario-web img { /*max-height: 120px;*/ border-radius: 6px; }
    .banner-bancario-web .bnw-arrow { width: 28px; height: 28px; }
    .banner-bancario-web .bnw-arrow.prev { left: 4px; }
    .banner-bancario-web .bnw-arrow.next { right: 4px; }
    .banner-bancario-web .bnw-inline-row { display: block; }
    .banner-bancario-web .bnw-inline-actions { display: none; }
    .banner-bancario-web .bnw-mobile-btn { display: flex; justify-content: center; margin-top: 8px; }
  }

  /* Móvil pequeño */
  @media (min-width: 401px) and (max-width: 576px) {
    .banner-bancario-web .slick-list { height: 140px; margin: 0; }
    .banner-bancario-web .slick-track { height: 140px; }
    .banner-bancario-web .slick-slide { height: 140px; padding: 0; width: 100% !important; }
    .banner-bancario-web .slick-slide > div { height: 140px; }
    .banner-bancario-web img { max-height: 140px; }
    .banner-bancario-web .bnw-arrow { width: 30px; height: 30px; }
    .banner-bancario-web .bnw-inline-row { display: block; }
    .banner-bancario-web .bnw-inline-actions { display: none; }
    .banner-bancario-web .bnw-mobile-btn { display: flex; justify-content: center; margin-top: 10px; }
  }

  /* Móvil grande */
  @media (min-width: 577px) and (max-width: 768px) {
    .banner-bancario-web .slick-list { height: 160px; margin: 0; }
    .banner-bancario-web .slick-track { height: 160px; }
    .banner-bancario-web .slick-slide { height: 160px; padding: 0; width: 100% !important; }
    .banner-bancario-web .slick-slide > div { height: 160px; }
    .banner-bancario-web img { max-height: 160px; }
    .banner-bancario-web .bnw-arrow { width: 34px; height: 34px; }
    .banner-bancario-web .bnw-inline-row { display: block; }
    .banner-bancario-web .bnw-inline-actions { display: none; }
    .banner-bancario-web .bnw-mobile-btn { display: flex; justify-content: center; margin-top: 10px; }
  }

  /* Tablet */
  @media (min-width: 769px) and (max-width: 992px) {
    .banner-bancario-web .slick-list { height: 180px; }
    .banner-bancario-web .slick-track { height: 180px; }
    .banner-bancario-web .slick-list { margin: 0 -12px; }
    .banner-bancario-web .slick-slide { height: 180px; padding: 0 12px; }
    .banner-bancario-web .slick-slide > div { height: 180px; }
    .banner-bancario-web img { max-height: 180px; }
    .banner-bancario-web .bnw-inline-row { display: block; }
    .banner-bancario-web .bnw-inline-actions { display: none; }
    .banner-bancario-web .bnw-mobile-btn { display: flex; justify-content: center; margin-top: 10px; }
  }

  /* Desktop pequeño */
  @media (min-width: 993px) and (max-width: 1200px) {
    .banner-bancario-web .slick-list { height: 190px; }
    .banner-bancario-web .slick-track { height: 190px; }
    .banner-bancario-web .slick-list { margin: 0 -14px; }
    .banner-bancario-web .slick-slide { height: 190px; padding: 0 14px; }
    .banner-bancario-web .slick-slide > div { height: 190px; }
    .banner-bancario-web img { max-height: 190px; }
  }

  /* Desktop grande */
  @media (min-width: 1201px) {
    .banner-bancario-web .slick-list { height: 200px; }
    .banner-bancario-web .slick-track { height: 200px; }
    .banner-bancario-web .slick-list { margin: 0 -16px; }
    .banner-bancario-web .slick-slide { height: 200px; padding: 0 16px; }
    .banner-bancario-web .slick-slide > div { height: 200px; }
    .banner-bancario-web img { max-height: 200px; }
  }

  /* Modal estilos */
  .bnw-modal-overlay {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0,0,0,0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    padding: 16px;
  }
  .bnw-modal-content {
    position: relative;
    background: #fff;
    border-radius: 8px;
    max-width: min(1000px, 92vw);
    width: 100%;
    max-height: 90vh;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .bnw-modal-content img {
    display: block;
    width: 90%;
    height: auto;
    max-height: 90vh;
    object-fit: contain;
  }
  .bnw-modal-close {
    position: absolute;
    top: 8px;
    right: 8px;
    background: transparent;
    border: none;
    border-radius: 0;
    width: auto; height: auto;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer;
    box-shadow: none;
    padding: 0;
  }
  .bnw-modal-close svg { width: 18px; height: 18px; }
`;

const BannerBancarioWeb = () => {
  const { banners } = useBanners();
  const [showModal, setShowModal] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < 768;
  });
  
  // Tomamos solo fila 3
  const fila3Banners = banners.fila3 || [];  
  // Filtrar banners que tengan imagen web
  const validBanners = fila3Banners.filter(banner => banner && banner.imagenWeb);
  
  // Bloquear scroll de fondo y cerrar con ESC cuando el modal está abierto (solo web)
  useEffect(() => {
    if (Platform.OS !== 'web') return;
    const body = document?.body;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setShowModal(false);
    };
    const onResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    if (showModal) {
      if (body) body.style.overflow = 'hidden';
      window.addEventListener('keydown', onKeyDown);
    } else {
      if (body) body.style.overflow = '';
      window.removeEventListener('keydown', onKeyDown);
    }
    window.addEventListener('resize', onResize);
    return () => {
      if (body) body.style.overflow = '';
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('resize', onResize);
    };
  }, [showModal]);
    
  // Si no hay banners, no renderizar nada
  if (validBanners.length === 0) {
    
    return null;
  }

  // Flechas personalizadas dentro del carrusel
  const PrevArrow = ({ onClick }) => (
    <ArrowButton className="bnw-arrow prev" direction="left" onPress={onClick} ariaLabel="Anterior" />
  );
  const NextArrow = ({ onClick }) => (
    <ArrowButton className="bnw-arrow next" direction="right" onPress={onClick} ariaLabel="Siguiente" />
  );

  // Configuración del carrusel (desktop: 3, tablet: 2, móvil: 1)
  const settings = {
    dots: false,
    infinite: validBanners.length > 3, // infinito solo si hay más de una vuelta completa
    speed: 500,
    slidesToShow: Math.min(3, validBanners.length),
    slidesToScroll: 1,
    adaptiveHeight: false,
    centerMode: false,
    variableWidth: false,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    pauseOnFocus: true,
    responsive: [
      {
        breakpoint: 1200, // desktop pequeño
        settings: {
          slidesToShow: Math.min(3, validBanners.length),
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992, // tablet
        settings: {
          slidesToShow: Math.min(2, validBanners.length),
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768, // móvil
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: false,
          arrows: true,
        },
      },
    ],
  };

  return (
    <div className="banner-bancario-web">
      <style dangerouslySetInnerHTML={{ __html: carouselStyles }} />
      <div className="bnw-inline-row">
        <div className="bnw-inline-actions">
          <div style={{ marginBottom: 6, fontWeight: 700, fontSize: 16, color: '#E30613', textAlign: 'center', fontFamily: 'Montserrat-Bold, Montserrat, sans-serif' }}>¡Mas promociones!</div>
          <button
            type="button"
            onClick={(e) => { e.preventDefault(); setShowModal(true); }}
            id="btn-ver-todos-promos-bancos"
            style={{
              backgroundColor: '#E30613',
              color: 'white',
              border: 'none',
              borderRadius: 8,
              padding: '12px 40px',
              fontWeight: 700,
              cursor: 'pointer'
            }}
          >
            Ver todos
          </button>
        </div>
        <div className="bnw-slider-col" style={{ position: 'relative' }}>
          <Slider {...settings}>
            {validBanners.map((banner) => {
              let imageUrl = banner.imagenWeb;
              if (!imageUrl.startsWith('http')) {
                imageUrl = BACKEND_URL + imageUrl;
              }
              return (
                <div key={banner.codBanner}>
                  <a
                    href={banner.link || '#'}
                    target={banner.link ? "_blank" : "_self"}
                    rel="noopener noreferrer"
                    onClick={(e) => {
                      if (!banner.link) {
                        e.preventDefault();
                      }
                    }}
                    style={{ display: 'block' }}
                  >
                    <img
                      src={imageUrl}
                      alt={banner.titulo || 'Banner'}
                      onError={(e) => {
                        e.target.src = '';
                      }}
                      style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                    />
                  </a>
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
      <div className="bnw-mobile-btn">
        <button
          type="button"
          onClick={(e) => { e.preventDefault(); setShowModal(true); }}
          id="btn-ver-todos-promos-bancos-mobile"
          style={{
            backgroundColor: '#E30613',
            color: '#FFFFFF',
            border: 'none',
            borderRadius: 8,
            padding: '12px 40px',
            fontWeight: 700,
            cursor: 'pointer'
          }}
        >
          Ver todos
        </button>
      </div>

      {showModal && Platform.OS === 'web' && ReactDOM.createPortal(
        (
          <div className="bnw-modal-overlay" role="dialog" aria-modal="true" onClick={() => setShowModal(false)}>
            <div className="bnw-modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="bnw-modal-close" aria-label="Cerrar" onClick={() => setShowModal(false)}>
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18M6 6l12 12" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <img 
                src={isSmallScreen
                  ? 'https://pinguino.com.ar/static/img/promot/planes-de-pago-movil.png'
                  : 'https://www.pinguino.com.ar/static/img/promot/planes-de-pago-web.jpg'}
                alt="Promociones Bancarias"
              />
            </div>
          </div>
        ), document.body
      )}
    </div>
  );
};

export default BannerBancarioWeb;
